const baseDetails = {
 title: {
   color: "#495057",
   fontSize: {
     xs: "0.8rem",
     md: "1rem",
     xl: "1.2rem",
   },
 },
 item: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    cursor: "helper",
 },
};

const styles = {
  root: {
    width: "100%",
  },
  textField: {
    color: "#495057",
  },
  fieldHolder: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
  },
  fieldBlock: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "49%",
  },
  editHolder: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  editFieldsBlockHolder: {
    display: "flex",
    justifyContent: "space-between",
    width: "inherit",
  },
  editButtonGroup: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "20px",
  },
  editAddressFields: {
    display: "flex",
    flexDirection: "column",
    width: "49%",
  },
  itemContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  itemHolder: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    margin: "10px 4px",
    alignItems: "center",
  },
  itemHolderUnits: {
    display: "grid",
    gridTemplateColumns: "auto minmax(0, 1fr) auto",
    alignItems: "center",
    columnGap: "24px",
    width: "100%",
    margin: "10px 4px",
  },
  titleDetails: {
   ...baseDetails.title,
    marginRight: "15px",
  },
  itemDetails: {
    ...baseDetails.title,
    flex: 1,
    minWidth: 0,
  },
  itemInfoDetails: {
    ...baseDetails.title,
    ...baseDetails.item,
    maxWidth: 500,
  },
  button: {
    display: "flex",
    width: "100%",
    margin: "10px auto 10px",
    color: "rgb(17,75,118)",
    "&:hover": {
      backgroundColor: "rgba(17,75,118,0.1)",
    },
  },
  infoHolder: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    justifyContent: "space-between",
    width: "90%",
  },
  iconHolder: {
    display: "flex",
    justifyContent: "space-between",
    verticalAlign: "bottom",
  },
  typeInfo: {
    display: "flex",
    width: "25%",
    minWidth: 0,
  },
  info: {
    display: "flex",
    flex: 1,
    minWidth: 0,
    width: "75%",
    marginLeft: "50px",
  },
  buttonHolder: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "15px",
  },
  buttonSave: {
    width: "110px",
    height: "40px",
    background: "rgba(4, 98, 54, 0.8)",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    borderRadius: "4px",
    fontFamily: "Poppins",
    fontStyle: "normal",
    lineHeight: "1.25em",
    fontSize: "14px",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "rgba(4, 98, 54, 0.9)",
      borderColor: "#046236",
      boxShadow: "none",
    },
  },
  buttonCansel: {
    marginLeft: "10px",
    width: "110px",
    height: "40px",
    background: "rgba(17,75,118,0.8)",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    borderRadius: "4px",
    fontFamily: "Poppins",
    fontStyle: "normal",
    lineHeight: "1.25em",
    fontSize: "14px",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "rgba(17,75,118,0.9)",
      borderColor: "#114B76",
      boxShadow: "none",
    },
  },
  editIcon: {
    color: "#114B76CC",
    fontSize: {
      xs: "0.8rem",
      md: "1rem",
      xl: "1.2rem",
    },
  },
  deleteIcon: {
    color: "#114B76CC",
    fontSize: {
      xs: "0.9rem",
      md: "1.1rem",
      xl: "1.2rem",
    },
  },
};

export default styles;
